// Provera pristupa internetu — isti pristup kao boot watchdog u index.html (konobar, KD):
// no-cors zahtev ka javnim serverima koji su "uvek gore", dva po imenu + jedan po IP adresi
// (imena ne rade, a IP radi = DNS/ruter). Bitno je samo da li veza uspe, ne sadržaj odgovora.
// ?ngsw-bypass: bez njega bi service worker na grešku mreže vratio izmišljen 504.
// ⚠ SYNC: ista lista servera je u boot watchdog skripti index.html-a.

export type InternetState = 'ok' | 'dns' | 'down';

const PROBES: { url: string; ip: boolean }[] = [
  { url: 'https://www.gstatic.com/generate_204', ip: false },
  { url: 'https://www.cloudflare.com/cdn-cgi/trace', ip: false },
  { url: 'https://1.1.1.1/cdn-cgi/trace', ip: true },
];

function probe(url: string, timeoutMs: number): Promise<boolean> {
  const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : undefined;
  const timer = setTimeout(() => ctrl?.abort(), timeoutMs);
  return fetch(url + '?ngsw-bypass=true', { mode: 'no-cors', cache: 'no-store', credentials: 'omit', signal: ctrl?.signal })
    .then(r => r.type === 'opaque' || r.ok, () => false)
    .finally(() => clearTimeout(timer));
}

/** 'ok' = bar jedan server po imenu odgovara; 'dns' = odgovara samo IP adresa; 'down' = nijedan. */
export async function checkInternet(timeoutMs = 6000): Promise<InternetState> {
  const results = await Promise.all(PROBES.map(p => probe(p.url, timeoutMs).then(ok => ({ ok, ip: p.ip }))));
  if (results.some(r => r.ok && !r.ip)) {
    return 'ok';
  }
  return results.some(r => r.ok && r.ip) ? 'dns' : 'down';
}

/** Lokalna adresa (LocalServer u LAN-u, localhost) — kad ona ne odgovara, internet nije uzrok. */
export function isLocalHostname(hostname: string): boolean {
  return /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)|\.local$|^\[?::1\]?$/i.test(hostname);
}
